export const addresses = {
  dotNounsToken: "0x3b14c6858883a232F72cA0c3BA140C393cB63525",
};
